import { FiltersDataKey, LoadedTablesDataKey, NewCustomerDataKey, SelectedTicketsDataKey } from "../constants"

export const useLocalStorageActions = () => {
    const get = (key: string): any => {
        return JSON.parse(localStorage.getItem(key) || '{}')
    }

    const save = (key: string, data: any) => {
        localStorage.setItem(key, JSON.stringify(data))
    }

    const remove = (key: string) => {
        localStorage.removeItem(key)
    }

    const getFiltersData = () => get(FiltersDataKey)
    const saveFiltersData = (data: any) => save(FiltersDataKey, data)

    const getSelectedTicketsData = (): string[] => {
        const data = get(SelectedTicketsDataKey)
        return Object.keys(data).length > 0 ? data : []
    }
    const saveSelectedTicketsData = (data: string[]) => save(SelectedTicketsDataKey, data)
    const removeSelectedTicketsData = () => remove(SelectedTicketsDataKey)

    const getLoadedTablesData = (): string[] => {
        const data = get(LoadedTablesDataKey)
        return Object.keys(data).length > 0 ? data : []
    }
    const saveLoadedTablesData = (data: string[]) => save(LoadedTablesDataKey, data)
    const removeLoadedTablesData = () => remove(LoadedTablesDataKey)
    
    const getNewCustomerData = () => get(NewCustomerDataKey)
    const saveNewCustomerData = (data: object) => save(NewCustomerDataKey, data)
    const removeNewCustomerData = () => remove(NewCustomerDataKey)

    return {
        getFiltersData,
        saveFiltersData,
        getSelectedTicketsData,
        saveSelectedTicketsData,
        removeSelectedTicketsData,
        getLoadedTablesData,
        saveLoadedTablesData,
        removeLoadedTablesData,
        getNewCustomerData,
        saveNewCustomerData,
        removeNewCustomerData
    }
}
